// Development utilities - only available in development mode
import { RoleTypes } from "../../types";
import { config } from "../../config";
import Logger from "./logger";

// Development credentials - only accessible when enabled
const getDevelopmentCredentials = (): Record<
  RoleTypes,
  { email: string; password: string }
> | null => {
  // Only return credentials when dummy data is enabled
  if (!config.enableDummyData) {
    return null;
  }

  return {
    Super_Admin: { email: "dev.hsmhusd-admin@yopmail.com", password: "12345" },
    LEA_Admin: { email: "lea@yopmail.com", password: "12345" },
    School_Admin: { email: "school@yopmail.com", password: "12345" },
    LEA_Sub_Admin: { email: "subadmin@yopmail.com", password: "12345" },
    Parent: { email: "parent@yopmail.com", password: "12345" },
    Teacher: { email: "teacher1@yopmail.com", password: "12345" },
    Student: { email: "student1@yopmail.com", password: "12345" },
    Clerk: { email: "clerk.af2@yopmail.com", password: "12345" },
    AttandanceCoordinator: {
      email: "coordinator@yopmail.com",
      password: "12345",
    },
    Default_Role: { email: "", password: "" },
  };
};

// Safe getter for development credentials
export const getDevCredentials = (
  role: RoleTypes
): { email: string; password: string } | null => {
  const credentials = getDevelopmentCredentials();
  if (!credentials) {
    if (config.enableDebug) {
      Logger.warn(
        "Development credentials not available - dummy data disabled"
      );
    }
    return null;
  }

  return credentials[role] || null;
};

// Check if development features should be enabled
export const isDevelopmentMode = (): boolean => {
  return config.isDevelopment();
};

// Check if specific development features are enabled
export const isFeatureEnabled = (feature: keyof typeof config): boolean => {
  return Boolean(config[feature]);
};

export default {
  getDevCredentials,
  isDevelopmentMode,
  isFeatureEnabled,
};
